import React, { useState } from "react";
import { FiArrowUpRight, FiCode, FiFlag, FiTrendingUp } from "react-icons/fi";
import { featuredSoftwareProjects } from "./data";
import SoftwareProjectModal from "./SoftwareProjectModal";

const previewIcons = {
  terminal: FiCode,
  markets: FiTrendingUp,
  golf: FiFlag
};

function ProductPreview({ project }) {
  const PreviewIcon = previewIcons[project.preview.type] ?? FiCode;

  return (
    <div className={`software-preview software-preview-${project.preview.type}`} aria-hidden="true">
      <div className="software-preview-bar">
        <span><i /><i /><i /></span>
        <strong>{project.preview.label}</strong>
      </div>
      <div className="software-preview-body">
        <PreviewIcon />
        <div>
          {project.preview.lines.map((line) => <code key={line}>{line}</code>)}
        </div>
      </div>
    </div>
  );
}

function FeaturedSoftwareProjects() {
  const [activeProject, setActiveProject] = useState(null);

  return (
    <section className="ops-section software-section" id="software">
      <div className="section-heading software-heading">
        <div>
          <p>Product Lab</p>
          <h2>Software products currently in development</h2>
        </div>
        <p className="section-intro">Three original products moving through active design, engineering, and validation.</p>
      </div>

      <div className="software-grid">
        {featuredSoftwareProjects.map((project) => (
          <article className="software-card glass-panel" key={project.name}>
            <ProductPreview project={project} />
            <div className="software-card-content">
              <div className="software-meta">
                <span>{project.code}</span>
                <span>{project.category}</span>
              </div>
              <span className="development-status"><i />{project.status}</span>
              <h3>{project.name}</h3>
              <p>{project.summary}</p>
              <div className="tool-row software-tools">
                {project.tools.slice(0, 4).map((tool) => <span key={tool}>{tool}</span>)}
              </div>
              <div className="software-actions">
                <button type="button" onClick={() => setActiveProject(project)}>Open Product Brief</button>
                {project.repository ? (
                  <a href={project.repository} target="_blank" rel="noreferrer">
                    {project.repositoryLabel}<FiArrowUpRight />
                  </a>
                ) : <span className="private-build">Private build</span>}
              </div>
            </div>
          </article>
        ))}
      </div>

      <SoftwareProjectModal project={activeProject} onClose={() => setActiveProject(null)} />
    </section>
  );
}

export default FeaturedSoftwareProjects;
